import { Col, Modal, Row, Steps } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { OverView } from "../components/overview";
import { Shipment } from "../components/shipment";
import { StorePickup } from "../components/storePickup";
import { Payment } from "../components/payment";
import { TransactionHistory } from "../components/transactionHistory";
import { OrderRemarks } from "../components/orderRemarks";
import TopRightLink from "../../../components/atoms/formFields/buttons/topRightLink";
import { useDispatch, useSelector } from "react-redux";
import {
  OrderBarThunk,
  OrderInStoreThunk,
  OrderOverviewThunk,
  OrderPaymentThunk,
  OrderShippingThunk,
  OrderTransactionThunk,
  PendingAmountThunk,
} from "../../../store/thunks/orderThunk";
import {
  resetApproveOrder,
  resetChangeStatusInstore,
  resetOrderChangeStatus,
} from "../../../store/slices/orderSlice";
import BloodSampleReport from "../components/BloodSampleReport";

export const SellerOrderHistory = ({}) => {
  const { Step } = Steps;
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    Pagination,
    Filters,
    selectedTab,
    ManifestCreation,
    shipmentSelection,
    InvoiceCreation,
    invoiceShipmentSelection,
  } = location?.state || {};

  const { data: overview } = useSelector((state) => state.orderOverview);
  const { data: transaction } = useSelector((state) => state.orderTransaction);
  const { data: payment } = useSelector((state) => state.orderPayment);
  const { data: shipping } = useSelector((state) => state.orderShipping);
  const { data: storePickup } = useSelector((state) => state.orderInStore);
  const { data: orderBar } = useSelector((state) => state.orderBar);
  const { data: approvorders } = useSelector((state) => state.approveOrder);
  const { data: changeStatus } = useSelector(
    (state) => state.changeStatusOrder,
  );
  const { data: changeStatusInStore } = useSelector(
    (state) => state.changeStatusInStore,
  );

  useEffect(() => {
    if (id) {
      dispatch(
        OrderOverviewThunk({
          orderRefId: id,
        }),
      );
      dispatch(
        OrderShippingThunk({
          orderRefId: id,
        }),
      );
    }
  }, [id]);

  useEffect(() => {
    if (approvorders || changeStatus || changeStatusInStore) {
      dispatch(
        OrderOverviewThunk({
          orderRefId: id,
        }),
      );
      dispatch(
        OrderShippingThunk({
          orderRefId: id,
        }),
      );
      dispatch(resetApproveOrder());
      dispatch(resetOrderChangeStatus());
      dispatch(resetChangeStatusInstore());
    }
  }, [approvorders, changeStatus, changeStatusInStore]);

  useEffect(() => {
    dispatch(
      OrderTransactionThunk({
        orderRefId: id,
      }),
    );
  }, [id]);

  useEffect(() => {
    dispatch(
      OrderPaymentThunk({
        orderRefId: id,
      }),
    );
  }, [id]);

  useEffect(() => {
    dispatch(
      OrderInStoreThunk({
        orderRefId: id,
      }),
    );
  }, [id]);

  useEffect(() => {
    dispatch(
      OrderBarThunk({
        orderRefId: id,
      }),
    );
  }, [id]);

  const [modal1Visible, setModal1Visible] = useState(false);

  const BloodSampleDiagnostics = overview?.orderItem?.some(
    (item) => item.productDomainCategory?.en === "Blood & Sample Diagnostics",
  );

  return (
    <>
      <Modal
        title="Detailed Timeline"
        centered
        visible={modal1Visible}
        onOk={() => setModal1Visible(false)}
        onCancel={() => setModal1Visible(false)}
      >
        <Steps
          progressDot
          current={1}
          direction="vertical"
          className="custom-steps"
        >
          <Step
            title="Confirmed"
            description="Your order Confirmed at 12:35:54 PM, Today"
          />
          <Step
            title="Packed"
            description="Your order Packed at 13:35:54 PM, Today"
          />
          <Step
            title="Shipped"
            description="Your order Shipped at 13:35:54 PM, Today"
          />
          <Step
            title="Out For Delivery"
            description="Your order Out For Delivery at 13:35:54 PM, Today"
          />
          <Step
            title="Delivered"
            description="Your order Delivered at 13:35:54 PM, Today"
          />
        </Steps>
      </Modal>

      <div className="content d-flex flex-column flex-column-fluid">
        <div className="container">
          <div className="align-items-center d-flex justify-content-end pb-6">
            <TopRightLink
              name="View All Orders"
              url={{
                pathname: "/Orders",
                state: {
                  PagiNation: Pagination,
                  Filters: Filters,
                  selectedTab: selectedTab,
                  ManifestCreation: ManifestCreation,
                  shipmentSelection: shipmentSelection,
                  InvoiceCreation: InvoiceCreation,
                  invoiceShipmentSelection: invoiceShipmentSelection,
                },
              }}
            />
          </div>
        </div>

        <div className="container">
          <div className="card-body card p-4">
            <Row gutter={[12, 12]} align="middle">
              <Col className="gutter-row" xs={24} lg={12}>
                <h4 className="font-weight-bolder mb-2">
                  Order: #{overview?.orderId}
                </h4>
                <p className="font-size-lg font-weight-bold mb-2">
                  <span className="font-weight-bolder">Payment Mode:</span>{" "}
                  {overview?.paymentMethod}{" "}
                  {overview?.isPreBooked ? "(Pre-Booked)" : ""}
                </p>
              </Col>
              <Col className="gutter-row" xs={24} lg={12}>
                <div className="align-items-end d-flex flex-column pb-6">
                  <div className="form-group m-0 row">
                    {(overview?.pendingCodAmount > 0 &&
                      shipping?.shippingInformation?.deliveryMode === "SELF") ||
                    (shipping?.shippingInformation?.deliveryMode === "SELF" &&
                      shipping?.shippingInformation?.externalDeliveryMode ===
                        "IN_HOUSE_SERVICE_SERVICE") ? (
                      <span
                        className="btn btn-success font-weight-bold mr-3"
                        onClick={() =>
                          dispatch(
                            PendingAmountThunk({
                              pendingAmountReceived: true,
                              orderRefID: id,
                            }),
                          )
                        }
                      >
                        Mark As Paid
                      </span>
                    ) : (
                      ""
                    )}
                    {overview?.isPreBooked && (
                      <span className="btn btn-warning font-weight-bold mr-3">
                        Pending Amount : ₹
                        {overview?.pendingCodAmount
                          ? overview?.pendingCodAmount
                          : overview?.grandTotal - overview?.amountPaid}
                      </span>
                    )}
                    <label className="col-form-label font-weight-bolder mr-4">
                      Order Status:
                    </label>
                    <div className="store_option">
                      <span className="btn btn-dark font-weight-bold letter-spacing btn-md cursor-none">
                        {overview?.orderStatus === "SHIPPED"
                          ? "IN_TRANSIT"
                          : overview?.orderStatus}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="mb-5 mt-0 separator separator-solid"></div>
            <div className="main-order-wrapper">
              <Row gutter={[12, 12]}>
                {/**Left Menu Start**/}
                <Col className="gutter-row" xs={24} lg={5}>
                  <div className="border border-1 border-light-dark h-100 rounded-top">
                    <div className="filter-bar bg-gray-700 text-white py-5 px-4 mb-0 h6 font-weight-bolder">
                      Menu
                    </div>
                    <ul className="nav flex-column nav-pills bg-white">
                      <li className="nav-item m-0">
                        <a
                          className="nav-link active radius-0 font-weight-bold"
                          data-toggle="tab"
                          href="#tab_pane_1"
                        >
                          Overview
                        </a>
                      </li>
                      <li className="nav-item m-0">
                        <a
                          className="nav-link radius-0 font-weight-bold"
                          data-toggle="tab"
                          href="#tab_pane_2"
                        >
                          Transaction History
                        </a>
                      </li>
                      {overview?.isFullPayment === false &&
                      overview?.isPreBooked ? (
                        ""
                      ) : (
                        <>
                          <li className="nav-item m-0">
                            <a
                              className="nav-link radius-0 font-weight-bold"
                              data-toggle="tab"
                              href="#tab_pane_3"
                            >
                              Shipment
                            </a>
                          </li>
                          <li className="nav-item m-0">
                            <a
                              className="nav-link radius-0 font-weight-bold"
                              data-toggle="tab"
                              href="#tab_pane_4"
                            >
                              Store Pickup
                            </a>
                          </li>
                        </>
                      )}

                      <li className="nav-item m-0">
                        <a
                          className="nav-link radius-0 font-weight-bold"
                          data-toggle="tab"
                          href="#tab_pane_5"
                          tabIndex="-1"
                          aria-disabled="true"
                        >
                          Payments
                        </a>
                      </li>
                      {BloodSampleDiagnostics && (
                        <li className="nav-item m-0">
                          <a
                            className="nav-link radius-0 font-weight-bold"
                            data-toggle="tab"
                            href="#tab_pane_7"
                            tabIndex="-1"
                            aria-disabled="true"
                          >
                            Blood Sample Report
                          </a>
                        </li>
                      )}

                      <li className="nav-item m-0">
                        <a
                          className="nav-link radius-0 font-weight-bold"
                          data-toggle="tab"
                          href="#tab_pane_6"
                          tabIndex="-1"
                          aria-disabled="true"
                        >
                          Remarks
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                {/**Left Menu End**/}

                {/**Tab Panel Start**/}
                <Col className="gutter-row" xs={24} lg={19}>
                  <div className="h-100 border border-0 tab-content">
                    <div
                      className="tab-pane fade active show"
                      id="tab_pane_1"
                      role="tabpanel"
                    >
                      <OverView overview={overview} />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="tab_pane_2"
                      role="tabpanel"
                    >
                      <TransactionHistory data={transaction} />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="tab_pane_3"
                      role="tabpanel"
                    >
                      <Shipment
                        data={shipping}
                        overview={overview}
                        mainOrderId={id}
                        orderBar={orderBar}
                        orderId={overview?.orderId}
                      />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="tab_pane_4"
                      role="tabpanel"
                    >
                      <StorePickup data={storePickup} orderRefId={id} />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="tab_pane_5"
                      role="tabpanel"
                    >
                      <Payment data={payment} />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="tab_pane_6"
                      role="tabpanel"
                    >
                      <OrderRemarks orderRefId={id} />
                    </div>

                    <div
                      className="tab-pane fade"
                      id="tab_pane_7"
                      role="tabpanel"
                    >
                      <BloodSampleReport orderRefId={id} overview={overview} />
                    </div>
                  </div>
                </Col>
                {/**Tab Panel Start**/}
              </Row>
            </div>
            ``
          </div>
        </div>
      </div>
    </>
  );
};
